var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99219 3.33887H2.32552C1.9719 3.33887 1.63276 3.47934 1.38271 3.72939C1.13266 3.97944 0.992188 4.31858 0.992188 4.6722V10.6722C0.992188 11.0258 1.13266 11.365 1.38271 11.615C1.63276 11.8651 1.9719 12.0055 2.32552 12.0055H8.32552C8.67914 12.0055 9.01828 11.8651 9.26833 11.615C9.51838 11.365 9.65885 11.0258 9.65885 10.6722V10.0055",
    stroke: "#032A4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99235 2.00528L10.9924 4.00528M11.9157 3.06195C12.1782 2.79938 12.3258 2.44327 12.3258 2.07195C12.3258 1.70062 12.1782 1.34451 11.9157 1.08195C11.6531 0.819382 11.297 0.671875 10.9257 0.671875C10.5544 0.671875 10.1982 0.819382 9.93568 1.08195L4.32568 6.67195V8.67195H6.32568L11.9157 3.06195Z",
    stroke: "#032A4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.615ddb37344ed73a0cf8c2443a0620ff.svg";
export { ForwardRef as ReactComponent };